import { FC } from 'react';

import { H2, P } from 'shared/components/Typography';
import { nevada } from 'shared/config/Colors';
import { Spacer } from 'shared/components/Layout';
import { Wrapper } from 'shared/components/Wrapper';

import { ACKTypeSheetContainer } from '../ACKTypeSheetContainer';
import { ACKTypeSheetProps } from '../../interface/ACKTypeSheetProps';
import ApprovedACKIcon from '../ApprovedACKIcon';
import { ACKTypeEnum } from '../../enums/ACKTypeEnum';

const ACKTypeSheet4: FC<ACKTypeSheetProps> = ({ approved, version }) => {
  return (
    <ACKTypeSheetContainer
      data-testid={`ack-sheet--${ACKTypeEnum['ASAP Acknowledgement approval required']}`}
    >
      <Wrapper inlineFlex>
        <H2 fontSize={24}>
          ASAP Acknowledgment - Approval Required
          {(version ?? 0) > 1 ? ` v${version}` : ''}
        </H2>
        {approved && (
          <ApprovedACKIcon
            data-testid={`ack-sheet-approved--${ACKTypeEnum['ASAP Acknowledgement approval required']}`}
          />
        )}
      </Wrapper>

      <Spacer h="12px" />

      <P color={nevada}>
        Please review the attached acknowledgement and drawing(s) immediately.
        Your signature is required to begin production.
      </P>
    </ACKTypeSheetContainer>
  );
};

export default ACKTypeSheet4;
